import * as React from 'react'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { NewDistributorForm } from './DistributorForm'

export default function AddDistributorDialog() {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  //handle form submit api here
  return (
    <div>
      <Button variant='contained' onClick={handleClickOpen}>
        Add Distributor
      </Button>

      <BootstrapDialog
        fullWidth
        sx={{ width: '80vw', maxWidth: '800px', mx: 'auto' }}
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle onClose={handleClose} >
          Add a new distributor
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ height: '60vh' }}>
          <NewDistributorForm handleClose={handleClose} />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
